import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { Auth0SignupResult } from 'src/app/shared/services/auth0.types';
import { environment } from 'src/environments/environment';
import { DoctorsNextRegisterStateService } from '../doctors-next-register-state.service';

@Component({
  selector: 'app-doctors-next-register',
  templateUrl: './doctors-next-register.component.html',
  styleUrls: [
    './doctors-next-register.component.css',
    '../style/index.css',
    '../style/registration.css',
  ],
})
export class DoctorsNextRegisterComponent
  extends BaseLoginComponent
  implements OnInit
{
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  isRegistable = true;
  public initialized: boolean = true;

  flagment?: string;

  birthdate: {
    year: string;
    month: string;
    date: string;
  } = {
    year: '2000',
    month: '01',
    date: '01',
  };
  birthdateMaster: {
    years: string[];
    months: string[];
    dates: string[];
  } = {
    years: Array.from({ length: 100 }, (_, i) =>
      (new Date().getFullYear() - i).toString()
    ),
    months: Array.from({ length: 12 }, (_, i) =>
      (i + 1).toString().padStart(2, '0')
    ),
    dates: Array.from({ length: 31 }, (_, i) =>
      (i + 1).toString().padStart(2, '0')
    ),
  };
  years: string[] = [];

  constructor(
    protected activateRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    protected spinner: NgxSpinnerService,
    public router: Router,
    public title: Title,
    private registerState: DoctorsNextRegisterStateService
  ) {
    super(activateRoute, auth0, dxauth, spinner, router, title);
  }

  async ngOnInit() {
    this.activateRoute.fragment.subscribe((fragment) => {
      this.flagment = fragment;
      if (!this.flagment) {
        this.email = '';
        this.password = '';
        this.confirmPassword = '';
        this.firstName = '';
        this.lastName = '';
        this.acceptTerm = false;
        this.acceptPrivacyPolicy = false;
      }
    });
  }
  async init(): Promise<void> {}

  submittable() {
    this.errorMessages.signup = {} as any;
    if (!this.email) {
      this.errorMessages.signup.email = 'メールアドレスを入力してください。';
    } else {
    }
    if (!this.password) {
      this.errorMessages.signup.password = 'パスワードを入力してください。';
    } else {
      const validation = DxauthService.passwordValidator(this.password, {
        minLength: 8,
      });
      if (!validation.isValid) {
        this.errorMessages.signup.password =
          '半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。';
      }
    }
    if (!this.confirmPassword) {
      this.errorMessages.signup.confirmPassword =
        '確認用パスワードを入力してください。';
    } else {
      if (this.password !== this.confirmPassword) {
        this.errorMessages.signup.confirmPassword =
          'パスワードが一致しませんでした。';
      }
    }
    if (!this.lastName) {
      this.errorMessages.signup.familyName = '姓を入力してください。';
    } else {
      if (this.lastName.length > 20) {
        this.errorMessages.signup.familyName =
          '姓は20文字以内で入力してください。';
      }
    }
    if (!this.firstName) {
      this.errorMessages.signup.givenName = '名を入力してください。';
    } else {
      if (this.firstName.length > 20) {
        this.errorMessages.signup.givenName =
          '姓は20文字以内で入力してください。';
      }
    }

    if (!this.acceptTerm) {
      this.errorMessages.signup.terms =
        'Doctors Next®の利用規約に同意する必要があります。';
    }
    if (!this.acceptPrivacyPolicy) {
      this.errorMessages.signup.privacyPolicy =
        'Doctors Next®の個人情報の取扱いについてに同意する必要があります。';
    }

    return (this.isRegistable =
      Object.keys(this.errorMessages.signup).length === 0);
  }

  /** 基本的に登録画面からの登録は医師 */
  registrationRole(): string {
    return this.registerState.selected.role || 'doctor';
  }

  get baseLink() {
    return environment.apps[this.clientId]?.appUrl;
  }

  async nextStep() {
    if (!this.submittable()) {
      return;
    }
    this.registerState.base = {
      email: this.email,
      password: this.password,
      familyName: this.lastName,
      givenName: this.firstName,
      birthdate: this.birthdate,
    };
    this.registerState.inputStep = 'speciality';
  }

  async getProfile() {
    const profile: { label: string; name: string; value: unknown }[] = [
      {
        label: '所属',
        name: 'affiliation',
        value: this.registerState.selected.affiliation,
      },
    ];
    const isRoleDoctor = this.registerState.selected.role === 'doctor';
    if (isRoleDoctor) {
      const selectedDepartment = this.registerState.selected.departments;
      const departmentMaster = await this.dxauth.getDepartments();
      // https://stg-id.dx-utility.com/management/api/v1/departments
      const selectedDepartmentIndexes = departmentMaster.departments
        .map((department, i) => ({
          label: department.label,
          index: i,
          isMatched: selectedDepartment.includes(department.label),
        }))
        .filter((e) => e.isMatched)
        .map((e) => e.index);
      profile.push({
        label: '診療科',
        name: 'departmentIndexes',
        value: selectedDepartmentIndexes,
      });
    }
    const isRoleOther = this.registerState.selected.role === 'others';
    if (isRoleOther) {
      profile.push({
        label: '職種（記入）',
        name: 'role_other',
        value: this.registerState.selected.othersDescription,
      });
    }

    return profile;
  }

  async _register() {
    if (!this.submittable()) {
      return;
    }
    const profile = await this.getProfile();

    // 入力値をセット
    const birthdate = this.registerState.base?.birthdate;
    this.birthDate = [birthdate?.year, birthdate?.month, birthdate?.date].join(
      '-'
    );

    const profileString = JSON.stringify(profile);
    const flags = await this.auth.getFlags({
      clientId: this.clientId,
      email: this.email,
      redirectUri: this.redirectUri,
    });

    // フラグが立っている場合は通常通り
    if (flags.doctors_products) {
      const _this = this;
      return this.register({
        profile: profileString,
        afterRegisterHook: async (e) => {
          return _this.callbackToNext(e);
        },
      }).then((e) => {
        // 実行時にエラーが設定されていたらエラーを表示
        this.isRegistable = this.isRegistable =
          Object.keys(this.errorMessages.signup).length === 0;
      });
    }

    // cp_productsがtrueの場合は連携ページへ遷移させる
    if (flags.cp_products) {
      // sessionStorageにメールアドレスを保存
      sessionStorage.setItem(
        sessionStorageKey.doctorsNextCpIntegration.email,
        this.email
      );
      await this.router.navigate([], {
        queryParamsHandling: 'preserve',
        fragment: 'doctors-next-cp-integration',
      });
      this.flagment = 'doctors-next-cp-integration';
      return;
    }

    // ともにfalseの場合は新規登録させる
    const _this = this;
    return this.register({
      profile: profileString,
      afterRegisterHook: async (e) => {
        return _this.callbackToNext(e);
      },
    }).then((e) => {
      // 実行時にエラーが設定されていたらエラーを表示
      this.isRegistable = this.isRegistable =
        Object.keys(this.errorMessages.signup).length === 0;
    });
  }

  private callbackToNext(e?: Auth0SignupResult) {
    if (!this.isRegistable) {
      return;
    }
    this.dxauth.dnextRegisterCallbck({
      auth0_sub: `auth0|${e?.Id}`,
      building_name: this.registerState.selected.building || '',
      city_address: this.registerState.selected.address || '',
      departments: this.registerState.selected.departments,
      industry_type: this.registerState.selected.industryType || '',
      prefectures: this.registerState.selected.pref || '',
      job_title_select: this.registerState.selected.position || '',
    });
  }
}
